module.exports = "<div class=\"damgage-location\" *ngIf=\"locationLoading\">\n    <image-map [mapData]=\"locationMapData\"\n    [bPreShowDamages]=\"true\"\n    [mapStyle] = \"locationMapStyle\"\n    [bCarmap]=\"false\"\n    (clickOnImage)=\"clickOnImage($event)\"\n    (loadImage)=\"loadedImage($event)\"></image-map>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/utilities/damage-location/damage-location.component.html
// module id = ../../../../../src/app/utilities/damage-location/damage-location.component.html
// module chunks = main